import { createSelector } from 'selectors'
import { constant } from './constant'

const getStickyBox = () => createSelector<HTMLElement>({ selector: constant.selector.stickyBox })

const getStickyBlocks = () =>
	createSelector<NodeListOf<HTMLElement>>({ selector: constant.selector.stickyBlocks }, true)

export const getStickyBlockSelectors = () => ({
	stickyBox: getStickyBox(),
	stickyBlocks: getStickyBlocks(),
})
